import { useLayoutEffect } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import { axios, ORGANIZATION_HEADER } from 'configs'
import { setQueryOrganizationId } from 'configs/queryClient'
import { routes } from 'constants/routes'
import { commonStrings } from 'constants/strings'
import { useAuth } from 'contexts/AuthContext'
import { useCurrentUser } from 'hooks'
import { EOrganizationMemberRole } from 'types'

/** ADMIN 画面は組織スコープ外。前組織のヘッダーとクエリ組織を子のクエリ登録より先に外す。 */
function clearOrganizationScope() {
  delete axios.defaults.headers.common[ORGANIZATION_HEADER]
  setQueryOrganizationId(null)
}

export function RequireAdmin() {
  const { user, loading } = useAuth()
  // OrganizationScope の cleanup より先に走る最初の render で外す（戻すのは OrganizationScope の render）
  clearOrganizationScope()
  useLayoutEffect(clearOrganizationScope, [])
  const { data: currentUser, isLoading: isCurrentUserLoading } = useCurrentUser()

  if (loading || (Boolean(user) && isCurrentUserLoading)) {
    return <p>{commonStrings.loadingEllipsis}</p>
  }

  if (!user) {
    return <Navigate to={routes.LOGIN} replace />
  }

  if (!currentUser || currentUser.role !== EOrganizationMemberRole.ADMIN) {
    // 組織スコープ外の権限エラーなので、入口ルーティング（/）に委ねる
    return <Navigate to={routes.HOME} replace />
  }

  return <Outlet />
}

